import React from 'react';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';
import * as S from './styles';

const DataListItem = ({ label, value, isLocal, isTop, styles, className }) => {
  const { data: match } = useSelector(state => state.matches.selectedMatch);
  return (
    <S.DataListItem
      {...styles}
      isLocal={isLocal}
      className={className}
      transparent={label === ''}
    >
      <S.DataListItemLabel {...styles} isLocal={isLocal}>
        {label}
      </S.DataListItemLabel>
      <S.Grow />
      <S.DataListItemBottom>
        {isTop && (
          <S.DataListItemIsTop>
            <S.DataListItemIsTopIcon size={11} name="star" color="yellow" />
            <span>Top 5</span>
          </S.DataListItemIsTop>
        )}
        <S.Grow />
        <S.DataListItemValue
          {...styles}
          isLocal={isLocal}
          competition={match?.competitionId}
        >
          {value || '-'}
        </S.DataListItemValue>
      </S.DataListItemBottom>
    </S.DataListItem>
  );
};

DataListItem.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isLocal: PropTypes.bool,
  isTop: PropTypes.bool,
  className: PropTypes.string,
  styles: PropTypes.object,
};

DataListItem.defaultProps = {
  label: '',
  value: '',
  isLocal: false,
  isTop: false,
  className: null,
  styles: null,
};

export default DataListItem;
